import { Component } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Product } from '../../models/products/product.model';
import { ProductService } from '../../services/product/product.service';

@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss']
})
/** Header-Search component*/
export class HeaderSearchComponent {
  public productList: Product[];
  public products: Array<any> = [];
  asyncSelected: string;
  typeaheadLoading: boolean;

  constructor(private readonly productService: ProductService) {

  }
  GetProducts() {
    this.productService.GetProducts().subscribe(
      data => {
        this.productList = data;

        for (var i = 0; i < this.productList.length; i++) {
          this.products.push({
            'id': this.productList[i].productID,
            'name': '<img id="" src="../../../assets/img/user5.png" width="50" /> <h5>' + this.productList[i].name + '</h5>',
            'actualName': this.productList[i].name
          });
        }
      }
    )
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  typeaheadOnSelect(e: TypeaheadMatch): void {
    
    this.asyncSelected = e.item.actualName;
  }

  LaodProducts(): void {
    if (this.products.length <= 0) {
      this.GetProducts();
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/header-search/header-search.component.ts